import { environment } from "src/environments/environment";

export const shouldBypassAssessmentSubmissionRequirements = (): boolean =>
    environment.bypassAssessmentSubmissionRequirements === true;
